var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinkUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5573_99257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 13.3332V18.3332H16.6663V13.3332C16.6663 12.4165 15.9163 11.6665 14.9997 11.6665H4.99967C4.08301 11.6665 3.33301 12.4165 3.33301 13.3332ZM14.9997 14.9998H4.99967V13.3332H14.9997V14.9998ZM9.99967 1.6665C7.69967 1.6665 5.83301 3.53317 5.83301 5.83317L9.99967 11.6665L14.1663 5.83317C14.1663 3.53317 12.2997 1.6665 9.99967 1.6665ZM9.99967 9.1665L7.49967 5.83317C7.49967 4.44984 8.61634 3.33317 9.99967 3.33317C11.383 3.33317 12.4997 4.44984 12.4997 5.83317L9.99967 9.1665Z",
    fill: "#EC407A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5573_99257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkUser);
export default __webpack_public_path__ + "static/media/pink-user.18ba746aff0cb50149c80953c72bd8cf.svg";
export { ForwardRef as ReactComponent };